module.exports = __webpack_public_path__ + "static/img/11d.0a66e29.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/art/11d.jpg
// module id = N6KI
// module chunks = 0